import $root from '@/proto/proto-bundle'

export const RpcService = {
  encodeRpcSendMessageClientRequest: (text) => new Promise((resolve) => {
    const builder = $root.lookup('RpcSendMessageClientRequest')
    const BodyTypes = $root.lookup('BodyTypes')
    const Text = $root.lookup('BodyTypes.Text')
    const bodyType = BodyTypes.create({
      text: Text.create({
        body: text
      })
    })
    const payload = builder.create({
      body: bodyType
    })
    resolve(builder.encode(payload).finish())
  })
}
